import "react";
import { Email } from "@therms/atalaya";
import { jsx } from "react/jsx-runtime";
import { Field, useFormikContext } from "formik";
// src/components/FormikFields/FormikEmail.tsx
var validateEmail = (email, required) => {
	if (required || !required && !!email) {
		let errorMessage;
		if (!/^[\w-\\.]+@([\w-]+\.)+[\w-]+$/i.test(email)) errorMessage = "Invalid email format. \"john@email.com\"";
		return errorMessage;
	}
};
var FormikEmail = (props) => {
	const form = useFormikContext();
	return /* @__PURE__ */ jsx(Field, {
		name: props.name,
		validate: (value) => validateEmail(value, props.required),
		children: ({ field, meta }) => /* @__PURE__ */ jsx(Email, {
			...props,
			error: (meta.touched || !!form.submitCount) && meta.error,
			valid: (meta.touched || !!form.submitCount) && meta.value && !meta.error,
			...field,
			onBlur: (e) => {
				if (props.onBlur) props.onBlur(e);
				field.onBlur(e);
			},
			onChange: (e) => {
				if (props.onChange) props.onChange(e);
				field.onChange(e);
			}
		})
	});
};
export { FormikEmail, validateEmail };

//# sourceMappingURL=FormikEmail.js.map